var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplaneDescent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "airplane-descent-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg airplane-descent",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airplane-descent") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2,26a10.66,10.66,0,0,1,.7,1.9,1.64,1.64,0,0,1,.1,1,1.72,1.72,0,0,1-1,1.2,2.92,2.92,0,0,1-1.6.1c-1.8-.3-3.3-1.7-4.8-2.7-1.3-.9-2.6-1.8-3.9-2.8-.8-.6-2.5-.1-3.5,0-4.3.4-8.7,1-13,1.5a4.82,4.82,0,0,1-1.2,0,3.51,3.51,0,0,1-.8-.5C1.5,25.2.8,24.6.1,24.1a.35.35,0,0,1-.1-.2c0-.1.1-.1.2-.2,2.1-.8,4.2-1.7,6.4-2.5,1.1-.4,2.1-.8,3.2-1.2.5-.2,1.1-.4,1.6-.6.2-.1,1-.2.8-.5,0-.1-.1-.1-.2-.1a13.59,13.59,0,0,1-3.6-2.7A27.9,27.9,0,0,1,5,12.6,18.52,18.52,0,0,1,2.9,9.3C2,8.2,2.7,6.3,3.2,5,3.4,4.4,5,.1,4.8,0c.5.3.9.7,1.4,1,0,.4.2.6.2,1.1C7,3.9,7.5,5.9,8,7.8c0,.1.1.2.1.3s.1.2.2.2a24.33,24.33,0,0,0,2.5,2c1.1.7,2.1,1.5,3.2,2.2,4.2,3,8.4,6,12.6,8.8C28.5,22.6,30.3,24,31.2,26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6,15.9c-1.8-1.2-3.5-2.5-5.2-3.8l-.3-.3a.6.6,0,0,1-.1-.4c.1-2.1.2-4.3.3-6.4a.37.37,0,0,1,.1-.3c.4-.4,2.4,1.3,2.8,1.5,1,.6,1,2.7,1.2,3.7a17.29,17.29,0,0,0,.7,3.1A29.31,29.31,0,0,1,20.6,15.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneDescent);
export default __webpack_public_path__ + "static/media/airplane-descent.1672767e11960871bbe5d605ee8df030.svg";
export { ForwardRef as ReactComponent };